module.exports = __webpack_public_path__ + "static/leahschaffer-557fcf69340a3e9145804148267a2b37.jpg";